/****************************************************
 * Module Name:  customerSellOutsourceProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CustomerSellOutsourceProxy {

    static getAllCustomerSellOutsourceOutputColumnNames = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/customerselloutsource/columns",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static createCustomerSellOutsource = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/customerselloutsource",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}